import { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@leroy-merlin-br/backyard-react-ui'
import { InfoCircle } from '@leroy-merlin-br/backyard-react-icons'

import * as S from './styled'

const Notification = ({
  type = 'default',
  children,
  hasClose = false,
  close = false,
  onClose
}) => {
  const [animating, setAnimating] = useState(false)
  const [isClosed, setIsClosed] = useState(false)

  const handleClose = useCallback(() => setAnimating(true), [setAnimating])
  const handleFinishAnimation = useCallback(() => {
    setIsClosed(true)
    onClose()
  }, [setIsClosed, onClose])

  if (isClosed || close) {
    return null
  }

  return (
    <S.Wrapper
      color={type}
      animating={animating}
      onAnimationEnd={handleFinishAnimation}
    >
      <S.IconWrapper>
        <Icon as={InfoCircle} size="giga" />
      </S.IconWrapper>

      <S.TextWrapper>
        {children}
      </S.TextWrapper>

      {hasClose && (
        <div>
          <S.Button data-testid="close-button" size="kilo" type="button" onClick={handleClose} />
        </div>
      )}
    </S.Wrapper>
  )
}

Notification.propTypes = {
  type: PropTypes.oneOf(['default', 'success', 'danger', 'warning']),
  children: PropTypes.node,
  hasClose: PropTypes.bool,
  close: PropTypes.bool,
  onClose: PropTypes.func
}

export default Notification
